<template>
    <section class="booking-details">
        <a class="tpone" :href="config.phone">
            <i></i>电话
        </a>
        <a class="talk" :href="config.talk">
            <i></i>咨询
        </a>
        <a class="btn" :class="{mt: isMT}" @click="showBookView">预约享优惠</a>
        <book-view :config="bookConfig"></book-view>
    </section>
</template>

<script>
import BookView from './BookView'

export default {
    data() {
        return {
            isMT: location.hostname.indexOf('meituan') > -1,
            bookConfig: {
                show: false,
                isLogin: this.config.isLogin,
                shopInfo: this.config.shopInfo
            }
        }
    },
    props: ['config'],
    methods: {
        showBookView(){
            this.bookConfig.show = true
        }
    },
    components: {
        BookView
    }
}
</script>

<style lang="less" scoped>
    .btn {
        background: #f90;
        border: 1px solid #f90;
        &.mt {
            background: #06C1AE;
            border: 1px solid #06C1AE;
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/BookFooter.vue